import { gql, TypedDocumentNode } from '@common/hooks';
import {
  SimulateShiftChangesQueryCgResponse,
  SimulateShiftChangesQueryVariables,
} from '@common/graphql/schema';

export const SIMULATE_SHIFT_CHANGES_QUERY: TypedDocumentNode<
  SimulateShiftChangesQueryCgResponse,
  SimulateShiftChangesQueryVariables
> = gql`
  query SimulateShiftChanges(
    $changes: [ShiftChangeSimulatorInput!]!
    $mode: ShiftChangeSimulationMode!
    $source: ShiftGapSource!
  ) {
    simulateShiftChanges(changes: $changes, mode: $mode, source: $source) {
      id
      startDatetime
      endDatetime
      durationHours
      timeOfDay
      prevCount
      newCount
      diffCount
      organizationUnit {
        id
        name
        organizationBusiness {
          name
        }
      }
      role {
        id
        name
        abbreviation
      }
      source
      timeZone
    }
  }
`;
